import { theme } from '@theme';
import styled from 'styled-components';

type HeaderProps = {
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  size: number;
  fontWeight?: number;
  color?: string;
  fontStyle?: string;
  display?: string;
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  backgroundColor?: string;
  textDecorationLine?: string;
  cursor?: string;
};

export const Typography = styled.span<HeaderProps>`
  background-color: ${(props) => props.backgroundColor ?? 'transparent'};
  font-size: ${(props) => props.size ?? theme.typography.fontSize}px;
  font-weight: ${(props) => props.fontWeight ?? theme.typography.fontWeights.normal} !important;
  margin-top: ${(props) => props.marginTop ?? 0}px;
  margin-bottom: ${(props) => props.marginBottom ?? 0}px;
  margin-left: ${(props) => props.marginLeft ?? 0}px;
  margin-right: ${(props) => props.marginRight ?? 0}px;
  font-style: ${(props) => props.fontStyle ?? props.fontStyle};
  color: ${(props) => props.color ?? theme.palette.darkGray};
  display: ${(props) => (props.display ? props.display : 'inline')};
  padding-top: ${(props) => props.paddingTop ?? 0}px;
  padding-bottom: ${(props) => props.paddingBottom ?? 0}px;
  padding-left: ${(props) => props.paddingLeft ?? 0}px;
  padding-right: ${(props) => props.paddingRight ?? 0}px;
  text-decoration-line: ${(props) => props.textDecorationLine ?? 'none'};
  cursor: ${(props) => props.cursor ?? 'auto'};
`;
